import React, { Component } from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";

export default class Title extends Component {

    render() {
        const { title, subtitle, size, align, bigTitle } = this.props;
        return (
            <div className={"Content-section" + 
                ( size === "wide" ? " Content-wide" : " Content-compact" ) +
                ( ( align === "center" || align === "" ) ? "" : 
                    ( align === "right" ? " Content-right" : 
                        ( align === "stretch" ? " Content-stretch" : " Content-left" ) 
                    )
                )
            }>
                <div className="Content-title">
                    { ( title !== undefined ) && 
                        <Typography
                            variant={bigTitle ? "h4" : "h5"}
                            color="primary"
                        >
                            {title}
                        </Typography>
                    }
                    { ( subtitle !== undefined ) && 
                        <Typography
                            variant="body1"
                            color="secondary"
                        >
                            {subtitle}
                        </Typography>
                    }
                </div>
            </div>
        );
    }

}

Title.propTypes = {
    title: PropTypes.node,
    subtitle: PropTypes.node,
    size: PropTypes.string,
    align: PropTypes.string
}